import { render, staticRenderFns } from "./Purchased.vue?vue&type=template&id=6d00d3d1&"
import script from "./Purchased.vue?vue&type=script&lang=ts&"
export * from "./Purchased.vue?vue&type=script&lang=ts&"
import style0 from "./Purchased.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
